// Match the bordered, rounded action menus used by MembershipActionMenu.
export const LAYOUT_MENU_PROPS = {
  PaperProps: {
    elevation: 0,
    sx: {
      mt: 0.5,
      minWidth: 220,
      maxWidth: "calc(100vw - 32px)",
      borderRadius: 2,
      border: "1px solid #e2e8f0",
      boxShadow: "0 12px 28px rgba(15, 23, 42, 0.12)",
      "& .MuiMenuItem-root": {
        mx: 0.5,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        fontSize: 13,
        color: "#334155",
        whiteSpace: "normal",
        "&:hover, &.Mui-focusVisible": { backgroundColor: "#f5f3ff" },
        "&.Mui-selected": { backgroundColor: "#ede9fe", color: "#6d28d9" },
      },
    },
  },
  anchorOrigin: { vertical: "bottom", horizontal: "center" },
  transformOrigin: { vertical: "top", horizontal: "center" },
};
